module.exports = __webpack_public_path__ + "img/um.50162f60.svg";